import React from 'react';

// Flecha de las secciones que se abren y cierran; apunta arriba cuando está abierta
const Chevron: React.FC<{ abierto: boolean }> = ({ abierto }) => (
  <svg
    className={`w-5 h-5 text-gray-400 flex-shrink-0 transition-transform ${abierto ? 'rotate-180' : ''}`}
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
  >
    <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
  </svg>
);

export default Chevron;
